<template>
  <div class="mathphys_box">
    <div class="mathphys_upload">
      <!-- <div>{{textarea}}</div> -->
      <!-- <div class="question-stem" v-html="textarea"></div> -->
      <div class="tit_top">问题</div>
      <div class="img_txt_fu">
 <div class="img_txt">
        <img v-if="imgUrl" :src="imgUrl" alt="" />
        <div class="txt_" v-else>
          <vue-mathjax :formula="textarea"></vue-mathjax>
        </div>
      </div>
      </div>
     
      <div class="tit_top">解析结果</div>
      <div class="answer_box question-stem" v-html="response_text"></div>
    </div>
  </div>
</template>

<script>
import uni from "@/utils/uni.webview.1.5.2"; // 自行下载
// import { Hub, Typeset } from 'mathjax-full/js/mathjax.js';
// import 'mathjax-full/es5/tex-mml-chtml.js';
import { VueMathjax } from "vue-mathjax";
import wx from "weixin-js-sdk";
import qs from "qs";
import $ from "jquery";
import html2canvas from "html2canvas";

export default {
  components: {
    "vue-mathjax": VueMathjax,
    jsCdn: {
      render(_) {
        return _("script", {
          attrs: {
            type: "text/javascript",
            src: this.cdn,
          },
        });
      },
      props: {
        cdn: {
          type: String,
          required: true,
        },
      },
    },
  },
  inject: ["reload"], // 注入函数
  watch: {
    $route: function (val) {
      this.reload();
    },
    question: function (value) {
      this.$nextTick(() => {
        window.MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
      });
    },
  },
  data() {
    return {
      token: "",
      questionId: "",
      textarea: "",
      response_text: "",
      imgUrl: "",
      time: 0,
    };
  },
  created() {
    if (this.$route.query.token) {
      this.token = this.$route.query.token;
      this.questionId = this.$route.query.questionId;
      this.detail();
    }
  },

  mounted() {},

  methods: {
    detail() {
      let formData = {
        questionId: this.questionId,
      };

      this.axios
        .get(
          "http://192.168.100.212:8200/user/question/info",

          {
            params: formData,
            headers: {
              token: `${this.token}`,
            },
          }
        )
        .then((response) => {
          let res = response.data;
          console.log(res);
          if (res.code == 0) {
            this.response_text = res.data.answer;
            this.textarea = res.data.inputText;
            // this.imgUrl = res.data.imgUrl;
            this.time = res.data.createTime;
            this.MathJax_txt();
          }
        })
        .catch((error) => {
          console.error(error);
          // 处理错误
        });
    },

    MathJax_txt() {
      this.$nextTick(function () {
        if (!this.MathJax.isMathjaxConfig) {
          //判断是否初始配置，若无则配置。
          this.MathJax.initMathjaxConfig();
        }
        this.MathJax.MathQueue("question-stem");
      });
    },
  },
};
</script>

<style　  lang="less" scoped>
.mathphys_box {
  display: flex;
  justify-content: center;
  .mathphys_ {
    max-width: 800px;
    padding: 30px;
    width: 100%;
  }
}
.mathphys_tit {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.btn_css {
  background: #0aaf88;
  border-color: #0aaf88;
  color: white;
  padding: 12px 20px;
  border-radius: 5px;
  display: inline-block;
  width: 95px;
}
.btn_tit {
  font-weight: 600 !important;
  font-size: 24px !important;
  color: rgb(37, 37, 37) !important;
  letter-spacing: 3px;
}
.mathphys_upload {
  margin: 20px ;
  width: 90%;
}
.operation_s {
  margin: 10px 0 0 0;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  img {
    width: 18px;
    margin: 0px 5px 0 0px;
    position: relative;
    top: 2px;
  }
}
.img_s {
  display: inline-block;
}
.icon_css {
  font-size: 21px;
}
.answer_box::-webkit-scrollbar {
  display: none;
}
.answer_box {
  margin: 10px 0;
  height: calc(100vh - 280px);
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  color: #606266;
  padding: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  overflow-x: hidden;
  overflow-y: scroll;
  text-align: left;
  line-height: 25px;
  white-space: pre-line;
}
.dialog_tit {
  background: #67cab3;
  color: #353535;
  height: 60px;
  line-height: 60px;
  text-align: center;
  letter-spacing: 3px;
  font-weight: 600;
  font-size: 20px;
  border-start-start-radius: 10px;
  border-start-end-radius: 10px;
}
.dialog_con {
  padding: 15px 20px;
  p {
    line-height: 24px;
    text-indent: 2em;
    text-align: left;
  }
}
.example_css {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 15px 0;
  color: #353535;
  /deep/ .el-checkbox__original {
    display: none;
  }
}
.example_btn_s {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.example_btn {
  background: #0aaf88;
  border-color: #0aaf88;
  color: white;
  padding: 8px 15px;
  border-radius: 5px;
  width: 100px;
  display: inline-block;
}
.dialog_css {
  /deep/ .el-dialog {
    border-radius: 10px;
  }

  /deep/ .el-dialog__header {
    display: none;
  }
  /deep/ .el-dialog__body {
    padding: 0;
    border-radius: 10px;
  }
}
.question-stem {
  white-space: pre-line;
}
/deep/ #mathDiv {
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;

  min-height: 90px;
  // line-height: 40px;
  outline: none;
  padding: 0 20px;
  margin: 10px 0 0 0;
}
/deep/ .mathquill-rendered-math {
  width: 100%;
  text-align: left;
  border: none;
  // background-color: #fff;
  // background-image: none;
  // border-radius: 4px;
  // border: 1px solid #dcdfe6;
  // box-sizing: border-box;
  // color: #606266;
  // // display: inline-block;
  // font-size: inherit;
  // height: 10px;
  // line-height: 10px;
  // outline: none;
  // padding: 0 15px;
}
/deep/ .hasCursor {
  box-shadow: none;
}
/deep/ .mathIcon {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
/deep/ .tabMenu {
  width: 100% !important;
}
/deep/ .math_one {
  height: auto !important;
}
/deep/ .tabTitle li {
  width: 30% !important;
}
.icon_css {
  position: relative;
}
.icon_ {
  position: absolute;
  top: -20px;
  right: 3px;
}
.tit_top {
  font-size: 18px;
  font-weight: 600;
  text-align: left;
  letter-spacing: 2px;
  margin: 10px 0;
}
.img_txt::-webkit-scrollbar {
  display: none;
}
.img_txt{
  
  height: 130px;
 
  color: #606266;
  padding: 10px;
  
  overflow-x: hidden;
  overflow-y: scroll;
  text-align: left;
  line-height: 25px;
  white-space: pre-line;
 
}
.img_txt_fu{
margin: 10px 0;
  padding:10px 0;
   border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
   background: white;
}
.txt_{
  text-align: left !important;
  line-height: 24px;
}
</style>